import React from 'react';
import PropTypes from 'prop-types';
import { Box, Collapse } from '@material-ui/core';
import { Typography } from '@orijinworks/frontend-commons';
import PlanStructureCard from './PlanStructureCard';
import TemplateDropdown from './TemplateDropdown';
import {
  PLAN_STRUCTURE_EMPTY,
  PLAN_STRUCTURE_TEMPLATE,
} from '../../../../utils/case-plan-create.util';
import SectionTitle from '../SectionTitle';
import { usePlanStructureSectionStyles } from './PlanStructureSection.styles';

const TEMPLATE_DROPDOWN_ANIMATION_MS = 250;

/**
 * Plan Structure / Starting Structure section: template/empty cards + dropdown.
 */
export const PlanStructureSection = ({
  title,
  planStructure,
  templates,
  selectedTemplate,
  onPlanStructureChange,
  onTemplateChange,
}) => {
  const classes = usePlanStructureSectionStyles();
  const showTemplateDropdown = planStructure === PLAN_STRUCTURE_TEMPLATE;

  return (
    <Box className={classes.root}>
      <SectionTitle title={title} />
      <Typography variant="body1" className={classes.description}>
        Start from a ready-made template, or an empty plan you build yourself.
      </Typography>
      <Box className={classes.selector}>
        <Box className={classes.widget}>
          <Box className={classes.cards}>
            <PlanStructureCard
              structureType={PLAN_STRUCTURE_TEMPLATE}
              title="Start from a template"
              description="Begin with a ready-made section structure you can adjust."
              selected={planStructure === PLAN_STRUCTURE_TEMPLATE}
              onSelect={onPlanStructureChange}
            />
            <PlanStructureCard
              structureType={PLAN_STRUCTURE_EMPTY}
              title="Empty plan"
              description="Start with a blank slate and build the sections yourself."
              selected={planStructure === PLAN_STRUCTURE_EMPTY}
              onSelect={onPlanStructureChange}
            />
          </Box>
          <Collapse
            in={showTemplateDropdown}
            timeout={TEMPLATE_DROPDOWN_ANIMATION_MS}
            unmountOnExit
          >
            <TemplateDropdown
              templates={templates}
              selectedTemplate={selectedTemplate}
              onTemplateChange={onTemplateChange}
            />
          </Collapse>
        </Box>
      </Box>
    </Box>
  );
};

PlanStructureSection.propTypes = {
  title: PropTypes.string,
  planStructure: PropTypes.oneOf([
    PLAN_STRUCTURE_TEMPLATE,
    PLAN_STRUCTURE_EMPTY,
  ]).isRequired,
  templates: PropTypes.arrayOf(PropTypes.object),
  selectedTemplate: PropTypes.object,
  onPlanStructureChange: PropTypes.func.isRequired,
  onTemplateChange: PropTypes.func.isRequired,
};

PlanStructureSection.defaultProps = {
  title: 'Plan Structure',
  templates: [],
  selectedTemplate: null,
};

export default PlanStructureSection;
